export function ResourcesPage() {
  return (
    <div className="bg-slate-950 py-24">
      <div className="mx-auto max-w-6xl px-6">
        <header className="max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-emerald-300">
            Resources
          </p>
          <h1 className="mt-4 text-4xl font-semibold text-white">
            Articles, playbooks, and workshops to advance mission-critical UX.
          </h1>
          <p className="mt-4 text-slate-300">
            AVUX shares frameworks and tools for teams navigating AI, compliance, and high-stakes operations.
          </p>
        </header>
        <div className="mt-16 grid gap-8 md:grid-cols-2">
          <article className="rounded-3xl border border-white/10 bg-white/5 p-8 text-slate-100">
            <h2 className="text-2xl font-semibold text-white">Articles & Playbooks</h2>
            <ul className="mt-3 space-y-2 text-sm text-slate-300">
              <li>UXDevOps & Storybook</li>
              <li>AI Experience Design Principles</li>
              <li>UX for Mission-Critical Systems</li>
            </ul>
          </article>
          <article className="rounded-3xl border border-white/10 bg-white/5 p-8 text-slate-100">
            <h2 className="text-2xl font-semibold text-white">Talks & Workshops</h2>
            <ul className="mt-3 space-y-2 text-sm text-slate-300">
              <li>AI UX Leadership</li>
              <li>Risk & Compliance UX</li>
              <li>Designing for Neurodiverse Teams</li>
            </ul>
          </article>
          <article className="rounded-3xl border border-white/10 bg-white/5 p-8 text-slate-100 md:col-span-2">
            <h2 className="text-2xl font-semibold text-white">Downloads</h2>
            <ul className="mt-3 space-y-2 text-sm text-slate-300">
              <li>UX metrics starter kit</li>
              <li>Mission-critical UX checklist</li>
            </ul>
          </article>
        </div>
      </div>
    </div>
  );
}
